import React, { FC, useState } from 'react'
import styles from './EditCompanyLegalInformation.module.css'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import * as yup from 'yup'
import { Formik, FormikValues } from 'formik'
import { createRoleCompanyFromEnToRu } from '../../utils/createRoleForRegister'
import CustomInput from '../UI/CustomInput/CustomInput'
import s from '../../styles/common/Form.module.css'
import iconEdit from '../../assets/icons/iconEdit.svg'
import {
  changeCompanyLegalInformation,
  getCurrentCompany,
} from '../../redux/actions/companiesAction'
import { ItemInfo } from '../ItemInfo/ItemInfo'
import CustomButton from '../UI/CustomButton/CustomButton'
import TitleBlockForEditPages from '../TitleBlockForEditPages/TitleBlockForEditPages'
import { useToast } from '../../context/ToastContext'

export type EditCompanyLegalInformationPropsType = {
  companyId: number
  companyName: string
  inn: string
  role: string | undefined
  contactFullName: string
  contactPhone: string
  email: string
}

const EditCompanyLegalInformation: FC<EditCompanyLegalInformationPropsType> = ({
  companyId,
  companyName,
  email,
  contactFullName,
  role,
  inn,
  contactPhone,
}) => {
  const [editMode, setEditMode] = useState(false)

  const { token, userRole } = useAppSelector((state) => state.auth)
  const { showSuccess, showError } = useToast()
  const dispatch = useAppDispatch()

  const validationSchema = yup.object().shape({
    companyName: yup.string().required('Поле является обязательным'),
    inn: yup.string().required('Поле является обязательным'),
    contactFullName: yup.string().required('Поле является обязательным'),
    contactPhone: yup.string().required('Поле является обязательным'),
    email: yup
      .string()
      .email('К сожалению, почта введена неверно, попробуйте еще раз')
      .required('Поле является обязательным'),
  })

  const handleSubmitHandler = async (values: FormikValues) => {
    const resultAction = await dispatch(
      changeCompanyLegalInformation({
        token,
        companyId: String(companyId),
        name: values.companyName,
        email: values.email,
        contactFullName: values.contactFullName,
        contactPhone: values.contactPhone,
      }),
    )

    if (changeCompanyLegalInformation.rejected.match(resultAction)) {
      showError('Произошла ошибка при изменении данных')
    } else {
      showSuccess('Данные успешно изменены')
      setEditMode(false)
      await dispatch(getCurrentCompany({ companyId: String(companyId), token }))
    }
  }

  const handleEditMode = () => {
    setEditMode(true)
  }

  return (
    <div className={styles.editCompanyShortInformation}>
      {editMode ? (
        <div className={styles.editMode}>
          <Formik
            initialValues={{
              companyName: companyName ? companyName : '',
              inn: inn ? inn : '',
              role: role ? createRoleCompanyFromEnToRu(role) : '',
              contactFullName: contactFullName ? contactFullName : '',
              contactPhone: contactPhone ? contactPhone : '',
              email: email ? email : '',
            }}
            validateOnBlur
            onSubmit={(values) => handleSubmitHandler(values)}
            validationSchema={validationSchema}
          >
            {(props) => {
              const { values, touched, errors, isValid, handleChange, handleBlur, handleSubmit } =
                props

              return (
                <>
                  <TitleBlockForEditPages
                    setEdit={setEditMode}
                    disabled={false}
                    title='Юридическая информация'
                    handleSubmit={handleSubmit}
                  />

                  <div className={styles.container}>
                    <div className={styles.companyNameBlock}>
                      <div className={styles.leftBlock}>Название организации</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='text'
                          placeholder=''
                          name='companyName'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.companyName}
                          className={
                            errors.companyName && touched.companyName
                              ? `${styles.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                      </div>
                    </div>
                    <div className={styles.companyNameBlock}>
                      <div className={styles.leftBlock}>Инн</div>
                      <div className={styles.rightBlock}>
                        <div className={styles.companyBlock}>{values.inn}</div>
                        {touched.inn && errors.inn && (
                          <p style={{ textAlign: 'start' }} className={s.errorValidation}>
                            {errors.inn}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className={styles.companyNameBlock}>
                      <div className={styles.leftBlock}>Роль</div>
                      <div className={styles.rightBlock}>
                        <div className={styles.companyBlock}>{values.role}</div>
                        {touched.role && errors.role && (
                          <p style={{ textAlign: 'start' }} className={s.errorValidation}>
                            {errors.role}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className={styles.companyNameBlock}>
                      <div className={styles.leftBlock}>ФИО контактного лица</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='text'
                          placeholder=''
                          name='contactFullName'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.contactFullName}
                          className={
                            errors.contactFullName && touched.contactFullName
                              ? `${styles.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                      </div>
                    </div>
                    <div className={styles.companyNameBlock}>
                      <div className={styles.leftBlock}>Номер телефона</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='text'
                          placeholder=''
                          name='contactPhone'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.contactPhone}
                          className={
                            errors.contactPhone && touched.contactPhone
                              ? `${styles.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                      </div>
                    </div>
                    <div className={styles.companyNameBlock}>
                      <div className={styles.leftBlock}>Электронная почта</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='email'
                          placeholder=''
                          name='email'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          className={
                            errors.email && touched.email
                              ? `${styles.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              )
            }}
          </Formik>
        </div>
      ) : (
        <div className={styles.staticInformation}>
          <div className={styles.header}>
            <h2 className={styles.title}>Юридическая информация</h2>
            {(userRole === 'superAdmin' ||
              userRole === 'admin' ||
              userRole === 'employeePlace' ||
              userRole === 'directorPlace' ||
              userRole === 'directorAgent') && (
              <CustomButton
                iconSrc={iconEdit}
                className={styles.btn}
                title={''}
                onClick={handleEditMode}
              />
            )}
          </div>
          <div className={styles.mainInformationContainer}>
            <ItemInfo title='Название организации' value={companyName} />
            <ItemInfo title='ИНН' value={inn} />
            <ItemInfo title='Роль' value={createRoleCompanyFromEnToRu(role) ?? ''} />
            <ItemInfo title='ФИО контактного лица' value={contactFullName} />
            <ItemInfo title='Номер телефона' value={contactPhone} />
            <ItemInfo title='Электронная почта' value={email} />
          </div>
        </div>
      )}
    </div>
  )
}

export default EditCompanyLegalInformation
